import React from 'react'

import TermsOfService from '/components/about/TermsOfService'

import './TermsOfServiceView.css'

const TermsOfServiceView = function({}) {
    return (
        <TermsOfService />
    )
}

export default TermsOfServiceView
